import { sva } from '@onbeam/business-styled-system/css';

export const subMenuStyles = sva({
  className: 'subMenu',
  slots: ['root', 'link', 'icon', 'content', 'label', 'arrow', 'subLabel'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    link: {
      display: 'flex',
      zIndex: 10,
      rounded: 'xs',
      transition: 'opacity',

      _hoverFocus: {
        opacity: 0.8,
      },
      '@media(min-width: calc(60rem + 1px))': {
        transition: 'colors',
        _hoverFocus: {
          bg: 'mono.quartenery',
        },
      },
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      flex: '1',
      justifyContent: 'center',
      textStyle: 'body-sm',
    },
    label: {
      textStyle: 'body-md',
      display: 'flex',
      alignItems: 'center',

      '@media(min-width: calc(60rem + 1px))': {
        textStyle: 'body-sm',
      },
    },
    arrow: {
      opacity: 0,
      transform: 'translate(-2px, 2px)',
      transitionProperty: 'opacity, transform',
      transitionDuration: 'fast',
      transitionTimingFunction: 'ease-in-out',
      flexShrink: 0,

      '.subGroup:is(:hover, :focus-visible) &': {
        opacity: 1,
        transform: 'translate(0, 0)',
      },
      '&[data-always-show-icon="true"]': {
        opacity: 1,
        transform: 'translate(0, 0)',
      },
    },
    subLabel: {
      color: 'mono.tertiary',
    },
  },
  variants: {
    variant: {
      default: {
        link: { p: '2.5', gap: '2.5' },
        icon: {
          p: '2',
          rounded: 'xxs',
          border: '[0.5px solid]',
          borderColor: 'opacity.lg',
          bg: 'mono.primaryFg',
        },
      },
      compact: {
        link: {
          py: '2.5',
          gap: '2',

          '@media(min-width: calc(60rem + 1px))': {
            px: '4',
          },
        },
        content: {
          justifyContent: 'center',
        },
        subLabel: {
          display: 'none',
        },
        arrow: {
          display: 'none',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
